var _path, _path2;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgProgress = function SvgProgress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 12c0 6.075-4.925 11-11 11S1 18.075 1 12 5.925 1 12 1s11 4.925 11 11ZM3.2 12a8.8 8.8 0 1 0 17.6 0 8.8 8.8 0 0 0-17.6 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.286 15.314 5.177-5.256a1.115 1.115 0 0 0-1.586-1.567l-4.575 4.618-1.174-1.234a1.113 1.113 0 0 0-1.613 0 1.113 1.113 0 0 0 0 1.536l1.796 1.886c.535.563 1.43.57 1.975.017Z"
  })));
};

export default SvgProgress;